/* eslint-disable no-unused-vars */
import { useQuery } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
// Services
import { getLeavePostsList, getLeavePost } from './leavePostService';
import * as Types from '../types';

/**
 * @description useQuery Hook to get the leave posts from a given year.
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} params
 * @param {Number|null} params.excludedEndSlotId
 * @param {Number|null} params.includedStartSlotId
 * @param {string|null} [params.resourceId]
 * @param {string|null} [params.status]
 * @param {string|null} [params.type]
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<{data:Array<Object>}, Error>}
 */
export const useLeavePostsListQuery = (queryParams, params, options) => useQuery({
  queryKey: ['postsList', queryParams, params],
  queryFn: () => getLeavePostsList(queryParams, params),
  meta: {
    preventToastError: true,
  },
  ...options,
});

/**
 * @description useQuery Hook to get a leave post from its ID.
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<Types.LeavePost, Error>}
 */
export const useLeavePostQuery = (queryParams, options) => useQuery({
  queryKey: ['remoteWorkingPost', queryParams],
  queryFn: () => getLeavePost(queryParams),
  ...options,
});
